import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { MuiButtonModule } from '../button';
import { MuiIconModule } from '../icon';
import { DEFAULT_MUI_TOAST_INDIVIDUAL_CONFIG } from './mui-toast-config';
import { MuiToast } from './mui-toast.component';


@NgModule({
  declarations: [
    MuiToast
  ],
  imports: [
    CommonModule,
    MuiIconModule,
    MuiButtonModule,
    ToastrModule.forRoot({
      ...DEFAULT_MUI_TOAST_INDIVIDUAL_CONFIG,
      toastComponent: MuiToast,
      autoDismiss: false,
      preventDuplicates: true,
      countDuplicates: true,
      resetTimeoutOnDuplicate: true,
      maxOpened: 3
    })
  ],
  exports: [
    MuiToast
  ]
})
export class MuiToastModule {}
